import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { IntuneSensorController } from '../controller/IntuneSensorController';

export class IntuneSensorComponent extends BaseSensorWebComponent {
  public controller!: IntuneSensorController;

  constructor() {
    super();
    this.sensorType = SensorType.INTUNE;
    this.initialSetup({
      controllerConstructor: IntuneSensorController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
